import React from 'react'
import {FiCalendar, FiCompass, FiList, FiUser, FiSettings} from 'react-icons/fi'
import {AiFillCar, AiOutlineLock} from "react-icons/ai";
import {HiOutlineKey, HiOutlineTemplate, HiOutlineTicket} from "react-icons/hi";
import {BiBarcodeReader, BiDevices} from "react-icons/bi";
import {BsFillFileRuledFill, BsPostageHeartFill, BsShieldLock} from "react-icons/bs";
import {GiTurnstile} from "react-icons/gi";
import {
    MdAttachMoney,
    MdBarcodeReader,
    MdDashboard,
    MdFaceUnlock,
    MdOutlineAdminPanelSettings,
    MdOutlineSubject, MdStadium
} from "react-icons/md";
import {TbPlugConnected} from "react-icons/tb";
import {GrValidate} from "react-icons/gr";
import {LuArrowLeftRight, LuBuilding2} from "react-icons/lu";
import {PiMapPinFill, PiPark} from "react-icons/pi";
import {TfiStatsUp} from "react-icons/tfi";
import {HiOutlineCommandLine} from "react-icons/hi2";
import {SiAdguard, SiJsonwebtokens} from "react-icons/si";
import {FaUserShield} from "react-icons/fa";
import {RiCodeSSlashLine} from "react-icons/ri";


export const SET_MENU = "SET_MENU";
export const CLEAR_MENU = "CLEAR_MENU";


export default function navigation(state = [], action) {
    switch (action.type) {
        case SET_MENU: {
            return getMenuItems(action.rights)
        }
        case CLEAR_MENU: {
            return []
        }
        default:
            return state
    }
}

const getMenuItems = (rights, userState) => {
    const initialState = [
        {
            title: '',
            items: [{url: '/dashboard', icon: <FiCompass size={20}/>, title: 'Dashboard', items: []}]
        }
    ]
    if (rights?.events) {
        initialState[0].items.push({url: '/events', icon: <FiCalendar size={20}/>, title: 'Události', items: []})
    }
    if (rights?.validation) {
    initialState[0].items.push({
        url: '/validation', icon: <GrValidate size={20}/>, title: 'Validace vstupenky', items: [],
        key: "validation"
    })
    }

    if (rights?.arenaEvents) {
        initialState[0].items.push({
            url: '/arena-events', icon: <FiCalendar size={20}/>, title: 'Aréna události', items: [],
            key: "arenaEvents"
        })
    }
    if (rights?.users) {
        initialState[0].items.push({
            url: '/users', icon: <FiUser size={20}/>, title: 'Uživatelé', items: [],
            key: "users"
        })
    }

    if (rights?.kioskLog) {
        initialState[0].items.push({
            url: '/kiosk-log', icon: <FiUser size={20}/>, title: 'Logy z kiosků', items: [],
            key: "kioskLog"
        })
    }

    if (rights?.parking) {
        initialState[0].items.push({
            url: '/parking', icon: <AiFillCar size={20}/>, title: 'Parkování ENIGOO', items: [
                {
                    url: '/parking/list', icon: <FiList size={20}/>, title: 'Vydané parkovací karty', items: [],
                    key: "parking-list"
                }
            ],
            key: "parking"
        })
    }

    if (rights?.cron) {
        initialState[0].items.push({
            url: '/cron', icon: <FiUser size={20}/>, title: 'Cron', items: [],
            key: "cron"
        })
    }

    if (rights?.vcb) {
        initialState[0].items.push({
            url: '', icon: <BsPostageHeartFill size={20}/>, title: 'Výstaviště ČB', items: [
                {
                    url: '/vcb/actual', icon: <FiUser size={20}/>, title: 'Aktuální stav', items: [],
                    key: "vcb-actual"
                }
            ],
            key: "vcb"
        })
    }
    if (rights?.readers) {
        initialState[0].items.push({
            url: '/readers', icon: <MdBarcodeReader size={20}/>, title: 'Čtečky', items: [],
            key: "readers"
        })
    }
    if (rights?.subjects) {
        initialState[0].items.push({
            url: '/subjects', icon: <MdOutlineSubject size={20}/>, title: 'Subjekty', items: [],
            key: "subjects"
        })
    }
    if (rights?.turniketRule) {
        initialState[0].items.push({
            url: '/rules', icon: <BsFillFileRuledFill size={20}/>, title: 'Pravidla turniketů', items: [],
            key: "turniketRules"
        })
    }
    if (rights?.connections) {
        initialState[0].items.push({
            url: '/connections', icon: <TbPlugConnected size={20}/>, title: 'Připojení', items: [],
            key: "connections"
        })
    }

    if (rights?.enigooTurnikets) {
        initialState[0].items.push({
            url: '/enigoo-turnstile', icon: <MdStadium size={20}/>, title: 'Správa areálu', items: [
                {
                    url: '/turnstile-dashboard', icon: <MdDashboard size={20}/>, title: 'Dashboard', items: [],
                    key: "turnstile-dashboard"
                },
                ...(rights?.superAdmin ? [{
                    url: '/enigoo-turnstile-config', icon: <FiSettings size={20}/>, title: 'Konfigurace', items: [],
                    key: "enigoo-turnstile-config"
                }] : []),
                {
                    icon: <GiTurnstile size={20}/>, title: 'Turnikety', items: [
                        {url:'/turnstile/list',title:'Seznam',icon:<FiList size={20}/>,key:'turnstile-list',items:[]},
                        {url:'/turnstile/command',title:'Příkazy',icon: <HiOutlineCommandLine size={20}/>, key:'turnstile-command',items:[]},
                        {url: '/turnstile/template', icon: <HiOutlineTemplate size={20}/>, title: 'Šablony', items: [],key:'turnstile-template'}
                    ],
                    key: "turnstile"
                },
                /*{
                    url: '/turnstile-map', icon: <PiMapPinFill size={20}/>, title: 'Mapa turniketů', items: [],
                    key: "turnstile-map"
                },*/
                {
                    url: '/tariff', icon: <MdAttachMoney size={20}/>, title: 'Tarify', items: [],
                    key: "tariff"
                },
                {
                    url: '/device', icon: <BiDevices size={20}/>, title: 'Zařízení', items: [],
                    key: "device"
                },
                {
                    url: '', icon: <HiOutlineTicket size={20}/>, title: 'Vstupenky', items: [
                        {
                            url:'/ticket/list', icon:<FiList size={20}/>, title:'Nahrané',
                            key:'imported-ticket', items:[]
                        },
                        {
                            url:'/ticket/check', icon:<MdBarcodeReader size={20}/>, title:'Kontrola',
                            key:'check-ticket', items:[]
                        }
                    ],
                    key: "ticket"
                },
                {
                    url: '/entrance', icon: <LuArrowLeftRight size={20}/>, title: 'Průchody', items: [],
                    key: "entrance"
                },
                {
                    url: '/face-recognition/stats', icon: <MdFaceUnlock size={20}/>, title: 'Rozpoznávání obličejů', items: [],
                    key: "face-recognition-stats"
                },
                {
                    url: '', icon: <PiMapPinFill size={20}/>, title: 'Zóny', items: [
                        {
                            url:'/zone/list',icon:<FiList size={20}/>, title: 'Seznam',items:[],key:'zone-list'
                        },
                        {
                            url:'/zone/stats',icon:<TfiStatsUp size={20}/>,title:"Statistiky",items:[],key:'zone-stats'
                        }
                    ],
                    key: "zone"
                },
                {
                    url: '/access', icon: <HiOutlineKey size={20}/>, title: 'Přístupy', items: [
                        {
                            url: '/access/user', icon: <FaUserShield size={20}/>, title: 'Uživatelé', items:[]
                        },
                        {url: '/access/token', icon: <RiCodeSSlashLine size={20}/>, title: 'Tokeny', items: [],}
                    ],
                    key: "access"
                }

            ],
            key: "enigooTurnikets"
        })
    }


    return initialState
}
